<template>
  <div class="container">

    <heading-one class="-margin-md">ご契約内容のご確認</heading-one>

    <p>「ご契約内容の事前のご案内」を必ずご確認いただき、ご契約の諾否をご選択ください。</p>

    <!--<table-box class="-entry _mb-20">
      <table-body>
        <table-row>
          <table-header>
            ご利用限度額
          </table-header>
          <table-data>
            <input-group class="-pctextright">
              {{userData.loan_credit_limit | numberToCurrency}}
            </input-group>
          </table-data>
        </table-row>
      </table-body>
    </table-box>-->

    <list-group class="-link _mb-sm-40 _mb-md-60">
      <list-item v-for="(report, index) in reports" href='#' class="-link" @click.prevent="showPdf(report)" :key="'report'+index">
        <element-box class="-center">
          <heading-icon class="_mb-0">
            ご契約内容の事前のご案内<icon-box src="pdf" class="-xs _ml-5"></icon-box>
          </heading-icon>
        </element-box>
      </list-item>
    </list-group>

    <form @submit.prevent="submitContractAgreement('1', $event)" novalidate>
      <btngroup-single class="_mb-sm-40">
        <btn-main class="-main" :disabled="disabled" @click.prevent="submitContractAgreement('1', $event)">
          承諾する
        </btn-main>
      </btngroup-single>
    </form>

    <btngroup-single class="-margin-lg">
      <btn-main class="-normal" @click.prevent="showCancelModal">
        承諾しない
      </btn-main>
    </btngroup-single>

    <modal-window v-if="isShowCancelModal" @close="hideCancelModal">
      <div class="inner">
        <p>「承諾しない」でよろしいですか？<br />お申し込みはキャンセルとなります。</p>
        <form @submit.prevent="submitContractAgreement('2', $event)" novalidate>
          <btngroup-single class="_mb-30">
            <btn-main class="-normal" @click.prevent="submitContractAgreement('2', $event)">承諾しない</btn-main>
          </btngroup-single>
        </form>
        <btngroup-single>
          <btn-close class="-close -md" @click.prevent="hideCancelModal">戻る</btn-close>
        </btngroup-single>
      </div>
    </modal-window>

  </div><!-- container -->
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataLambdaInvoke, submitContractAgreementLambdaInvoke, contractAgreementLambdaInvoke, getUserSessionLambdaInvoke, apiGetPdfFile } from '../utils/LambdaHelper'
import HeadingOne from '../components/heading/HeadingOne'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import InputGroup from '../components/input/InputGroup'
import InputgroupAppend from '../components/input/InputgroupAppend'
import InputAppend from '../components/input/InputAppend'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import ElementBox from '../components/elements/element-box'
import HeadingIcon from '../components/heading/HeadingIcon'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ModalWindow from '../components/modal/ModalWindow'
import BtnClose from '../components/button/BtnClose'
import IconBox from '../components/icons/icon-box'

export default {
  name: 'En-012',
  metaInfo: {
    title: 'ご契約内容のご確認',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ご契約,確認'}
    ]
  },
  components: {
    IconBox,
    BtnClose,
    ModalWindow,
    BtnMain,
    BtngroupSingle,
    HeadingIcon,
    ElementBox,
    ListItem,
    ListGroup,
    InputAppend,
    InputgroupAppend,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne
  },
  data () {
    return {
      errors: {},
      userData: {
        loan_credit_limit: '0', // ご利用限度額
        loan_contractual_interest_rate: '0' // お借り入れ利率（実質年率）
      },
      contractAgreement: {
        contract_agreement: '',
        contract_increased_type: '1' // 1固定
      },
      reports: [],
      pdfList: {},
      userSessionData: {
        user_session: '',
        state: ''
      },
      isShowCancelModal: false,
      disabled: 'disabled',
      isDisabled: false
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
      contractAgreementLambdaInvoke().then(res => {
        let resBody = JSON.parse(res.body)
        let pdfList = resBody.pdf_list
        for (let pdf of pdfList) {
          for (let report of pdf.reports) {
            if (report.report_type === '01') {
              this.reports.push(report)
            }
          }
        }
        this.sortReports()
      }).catch(error => {
        this.goToErrorPage(error)
      })
      getUserSessionLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userSessionData.hasOwnProperty(key)) {
            this.userSessionData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    submitContractAgreement (contractAgreement) {
      try {
        if (this.isDisabled || (this.disabled && contractAgreement === '0')) {
          return
        }
        this.errors = {}
        this.isDisabled = true
        this.contractAgreement.contract_agreement = contractAgreement
        initCredentials().then(res => {
          submitContractAgreementLambdaInvoke(this.contractAgreement).then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              if (this.contractAgreement.contract_agreement === '1') {
                this.$router.push({name: 'en013'})
              } else if (this.contractAgreement.contract_agreement === '2') {
                this.$router.push({name: 'en014'})
              }
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    sortReports () {
      this.reports.sort(function (a, b) {
        if (a.create_date < b.create_date) return -1
        if (a.create_date > b.create_date) return 1
        return 0
      })
    },
    showCancelModal () {
      this.isShowCancelModal = true
    },
    hideCancelModal () {
      this.isShowCancelModal = false
    },
    showPdf (report) {
      this.disabled = null
      const userSession = this.userSessionData.user_session
      const reportId = report.report_id
      const reportType = report.report_type
      const state = this.userSessionData.state

      apiGetPdfFile({user_session: userSession, report_id: reportId, report_type: reportType, state: state}).then(res => {
        if (window.navigator.msSaveBlob) {
          // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
          window.open(`${process.env.GET_PDF_FILE}?user_session=${userSession}&report_id=${reportId}&report_type=${reportType}&state=${state}`, '_blank')
        } else {
          // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
          window.open(`${process.env.GET_PDF_FILE}?user_session=${userSession}&report_id=${reportId}&report_type=${reportType}&state=${state}`, '_blank')
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .heading-icon {
    justify-content: flex-start !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/En012.vue